import { render } from "./modal.vue?vue&type=template&id=d9976d88&scoped=true"
const script = {}

import "./modal.vue?vue&type=style&index=0&id=d9976d88&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9976d88"]])

export default __exports__